module.exports = __webpack_public_path__ + "img/pyro_f.e086865c.png";